// ModalProvider.js
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import ModalContext from './ModalContext';
import { getDamRecordById } from '../../Pages/DAM/store/DAM.action';
import { getDamProductRecordById } from '../../Pages/DevlopmentOrder/Dam/DamFiles/store/DamFile.action';

function ModalProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [damFileId, setDamFileid] = useState(null);
  const [damDevOrderId, setDamDevOrderId] = useState(null);

  const [modalData, setModalData] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const callFn = async () => {
      let res = null;
      if (damDevOrderId) {
        res = await dispatch(getDamProductRecordById(damFileId, damDevOrderId));
      } else {
        res = await dispatch(getDamRecordById(damFileId));
      }
      if (res?.code === 200) {
        setModalData(res?.data);
      }
    };
    if (damFileId && isModalOpen) {
      callFn();
    }
  }, [damFileId, isModalOpen, dispatch, damDevOrderId]);

  const contextValue = useMemo(
    () => ({
      isModalOpen,
      openModal,
      closeModal,
      modalData,
      setModalData,
      setDamFileid,
      setDamDevOrderId,
    }),
    [isModalOpen, openModal, closeModal, modalData, setModalData, setDamFileid, setDamDevOrderId],
  );

  return <ModalContext.Provider value={contextValue}>{children}</ModalContext.Provider>;
}

export default ModalProvider;
